import createSagaMiddleware from 'redux-saga';
import { rootSaga, } from 'store/ducks';

export const sagaMiddleware = createSagaMiddleware();
export const runSaga = () => sagaMiddleware.run(rootSaga);
